// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2skB0","row":"styles_row__3CoK_"};